import {
  NotificationChannelSchema,
  type NotificationChannel as GeneratedNotificationChannel
} from '~/services/api/generated'

// Mirrors backend App\Enums\Notification\NotificationChannel

export type NotificationChannel = GeneratedNotificationChannel

export const NotificationChannel = {
  EMAIL: NotificationChannelSchema.enum.email,
  SMS: NotificationChannelSchema.enum.sms,
  IN_APP: NotificationChannelSchema.enum.in_app
} satisfies Record<string, GeneratedNotificationChannel>

export const NotificationChannelValues: readonly GeneratedNotificationChannel[] = [
  NotificationChannelSchema.enum.email,
  NotificationChannelSchema.enum.sms,
  NotificationChannelSchema.enum.in_app
]
